/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Sales_Meta_TitleInputs */

const id_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ms_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const da_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const de_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const en_us2_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const es_es2_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const es_mx2_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const fil_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const fr_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const it_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const hu_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const nl_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const no_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const pl_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const pt_br2_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const pt_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ro_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const fi_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const sv_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const vi_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const tr_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const cs_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const bg_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ru_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const uk_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ar_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const hi_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const th_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ja_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const zh_cn2_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const zh_hant1_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ko_sales_meta_title = /** @type {(inputs: Sales_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

/**
* | output |
* | --- |
* | "{title} \| egdata.app" |
*
* @param {Sales_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_meta_title = /** @type {((inputs: Sales_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_meta_title(inputs)
	if (locale === "ms") return ms_sales_meta_title(inputs)
	if (locale === "da") return da_sales_meta_title(inputs)
	if (locale === "de") return de_sales_meta_title(inputs)
	if (locale === "en-US") return en_us2_sales_meta_title(inputs)
	if (locale === "es-ES") return es_es2_sales_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_sales_meta_title(inputs)
	if (locale === "fil") return fil_sales_meta_title(inputs)
	if (locale === "fr") return fr_sales_meta_title(inputs)
	if (locale === "it") return it_sales_meta_title(inputs)
	if (locale === "hu") return hu_sales_meta_title(inputs)
	if (locale === "nl") return nl_sales_meta_title(inputs)
	if (locale === "no") return no_sales_meta_title(inputs)
	if (locale === "pl") return pl_sales_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_sales_meta_title(inputs)
	if (locale === "pt") return pt_sales_meta_title(inputs)
	if (locale === "ro") return ro_sales_meta_title(inputs)
	if (locale === "fi") return fi_sales_meta_title(inputs)
	if (locale === "sv") return sv_sales_meta_title(inputs)
	if (locale === "vi") return vi_sales_meta_title(inputs)
	if (locale === "tr") return tr_sales_meta_title(inputs)
	if (locale === "cs") return cs_sales_meta_title(inputs)
	if (locale === "bg") return bg_sales_meta_title(inputs)
	if (locale === "ru") return ru_sales_meta_title(inputs)
	if (locale === "uk") return uk_sales_meta_title(inputs)
	if (locale === "ar") return ar_sales_meta_title(inputs)
	if (locale === "hi") return hi_sales_meta_title(inputs)
	if (locale === "th") return th_sales_meta_title(inputs)
	if (locale === "ja") return ja_sales_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_meta_title(inputs)
	return ko_sales_meta_title(inputs)
});
export { sales_meta_title as "sales.meta.title" }